<template>
  <div class="bg-baioro-dark pa-2">
    <div class="bg-green-100 border border-green-500 text-green-900 p-4 text-center max-w-3xl mx-auto">Je reservatie werd doorgegeven, we contacteren jou zo snel mogelijk.</div>
  </div>
</template>

<script>
export default {}
</script>
